import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { customAuthAxios } from '../../utils/customAuthAxios';
import { useSuccessToast } from '../toast/useSuccessToast';


export const useSubmitManagerPassEdit = (managerId: string) => {
  const navigate = useNavigate();
  const showToast = useSuccessToast();

  const editPass = async (data: any) => {
    return await customAuthAxios.put(`authentication/managers/${managerId}/change-password/`, data);
  };

  const onSubmit = useCallback(async (data: any) => {
    try {
      const res = await editPass(data);
      showToast(res.data.message);
      navigate(-1);
    } catch (error: any) {
    }
  }, [navigate]);

  return onSubmit;
};